const httpUrl = 'https://api.any2order.com'
//const httpUrl = 'http://localhost:5566'
export default {
    httpUrl
}